import { tva } from '@gluestack-ui/utils/nativewind-utils'
import React from 'react'

import { Box } from '../box'

export type SeverityLevel = 'critical' | 'warning' | 'caution' | 'success' | 'neutral' | 'info'
export type SeverityTaskItemSize = 'big' | 'small'

export type SeverityTaskItemProps = {
    level: SeverityLevel
    /** `big` = 24px, `small` = 8px (Figma node 7009:43947). */
    size?: SeverityTaskItemSize
    className?: string
    testID?: string
}

const severityTaskItem = tva({
    base: 'rounded-full',
    variants: {
        level: {
            critical: 'bg-status-critical',
            warning: 'bg-status-warning',
            caution: 'bg-status-caution',
            success: 'bg-status-success',
            neutral: 'bg-status-neutral',
            info: 'bg-status-info',
        },
        size: {
            big: 'size-6',
            small: 'size-2',
        },
    },
})

/**
 * Severity indicator dot matching the Figma redesign (AOS-606): a filled circle
 * in the severity colour, at `big` (24px) or `small` (8px). Decorative — pass a
 * meaningful `accessibilityLabel` via the host when it conveys state.
 */
export const SeverityTaskItem: React.FC<SeverityTaskItemProps> = ({
    level,
    size = 'big',
    className,
    testID,
}) => (
    <Box
        className={severityTaskItem({ level, size, class: className })}
        accessibilityLabel={level}
        testID={testID}
    />
)

SeverityTaskItem.displayName = 'SeverityTaskItem'
